import { component } from 'picoapp'

export default component((node, ctx) => {
    
    const searchField = node.querySelector('.faq-search-field');
    const searchBtn = node.querySelector('.faq-search-btn');
    const faqItems = document.querySelectorAll('.faq-heading');

    function searchFaqs() {
        let searchTerm = searchField.value;
        let applySearch = searchTerm.length > 0;
        let regSearch = new RegExp(searchTerm, "i");

        for (const faq of faqItems) {
            let header = faq;
            let content = faq.nextElementSibling;
            if (applySearch) {
                if (header.textContent.match(regSearch) || content.textContent.match(regSearch)) {
                    header.style.display = null;
                    content.style.display = null;
                } else {
                    header.style.display = "none";
                    content.style.display = "none";
                }
            } else {
                header.style.display = null;
                content.style.display = null;
            }
        }
    }

    searchField.addEventListener('keyup', e => {
        searchFaqs();
    });

    searchBtn.addEventListener('click', e => {
        e.preventDefault();
        searchFaqs();
    });

})
